/**
 * 🏢 RESPONSIBLE COMPLETE PAGE
 * Página para finalizar cadastro de responsável incompleto
 */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import ResponsibleFinalizationForm from '../components/responsibles/ResponsibleFinalizationForm';
import { API_URL } from '../config/api';

const ResponsibleCompletePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [responsible, setResponsible] = useState(null);
  const [loading, setLoading] = useState(true);

  // Carregar dados do responsável
  useEffect(() => {
    const loadResponsible = async () => {
      try {
        const token = localStorage.getItem('token');
        
        console.log('🔍 Carregando responsável para finalização:', id);
        
        const response = await fetch(`${API_URL}/api/responsibles/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        const data = await response.json();
        
        if (response.ok && data.success) {
          console.log('✅ Responsável carregado:', data.data);
          setResponsible(data.data);
        } else {
          throw new Error(data.message || 'Erro ao carregar responsável');
        }
        
      } catch (error) {
        console.error('❌ Erro ao carregar responsável:', error);
        toast.error('Erro ao carregar dados do responsável');
        navigate('/responsibles');
      } finally {
        setLoading(false);
      }
    };
    
    loadResponsible();
  }, [id, API_URL, navigate]);

  // Handler de sucesso
  const handleSuccess = (updatedResponsible) => {
    console.log('✅ Cadastro finalizado com sucesso:', updatedResponsible);
    toast.success('Cadastro finalizado! Aguarde aprovação da equipe.');
    navigate('/responsibles');
  };

  // Handler de cancelamento
  const handleCancel = () => {
    navigate('/responsibles');
  };

  if (loading) {
    return (
      <MasterLayout>
        <Breadcrumb 
          title="Finalizando Cadastro..." 
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Responsáveis', path: '/responsibles' }
          ]}
        />
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-3">Carregando dados...</p>
          </div>
        </div>
      </MasterLayout>
    );
  }

  if (!responsible) {
    return (
      <MasterLayout>
        <Breadcrumb 
          title="Erro" 
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Responsáveis', path: '/responsibles' }
          ]}
        />
        <div className="alert alert-danger mt-4">
          Responsável não encontrado.
        </div>
      </MasterLayout>
    );
  }

  return (
    <MasterLayout>
      <Breadcrumb 
        title="Finalizar Cadastro" 
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Responsáveis', path: '/responsibles' }
        ]}
      />
      
      <ResponsibleFinalizationForm
        responsible={responsible}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </MasterLayout>
  );
};

export default ResponsibleCompletePage;

